import { render, staticRenderFns } from "./TikTokAds.vue?vue&type=template&id=43f9f2fa&scoped=true&"
import script from "./TikTokAds.vue?vue&type=script&lang=js&"
export * from "./TikTokAds.vue?vue&type=script&lang=js&"
import style0 from "./TikTokAds.vue?vue&type=style&index=0&id=43f9f2fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f9f2fa",
  null
  
)

export default component.exports